// Shared values for profile + preferences chip pickers
export const VALUE_CHIPS = [
    "honesty", "loyalty", "humor", "curiosity", "growth", "ambition",
    "kindness", "presence", "directness", "adventure", "discipline",
    "depth", "ease", "creativity", "stability", "spirituality",
];

export const LIFESTYLE_OPTIONS = {
    drinks: ["never", "rarely", "socially", "often"],
    smokes: ["no", "socially", "yes"],
    exercise: ["rarely", "weekly", "daily"],
};

export const PRONOUNS = ["she / her", "she / they", "they / them", "he / him", "other"];

export const CHILDREN_PLANS = [
    { value: "yes", label: "Want children" },
    { value: "open", label: "Open to children" },
    { value: "no", label: "Don't want children" },
];

export const SECTIONS = [
    { id: "basics", label: "About you", required: true },
    { id: "photos", label: "Photos", required: true },
    { id: "live", label: "Live photo", required: true },
    { id: "video", label: "Video prompt", required: false },
    { id: "preferences", label: "Your ideal partner", required: true },
];

export const HEIGHT_CM_MIN = 140;
export const HEIGHT_CM_MAX = 210;
export const AGE_MIN = 21;
export const AGE_MAX = 70;
export const DISTANCE_MAX_KM = 200;

// --- Structured "what you want in a partner" chips ---
export const RELATIONSHIP_INTENTS = [
    { value: "life-partner", label: "Life partner / marriage" },
    { value: "long-term", label: "Serious long-term" },
    { value: "see-where-it-goes", label: "Dating to see where it goes" },
    { value: "intentional-friendship", label: "Intentional friendship first" },
];

export const COMMUNICATION_STYLES = [
    "direct", "gentle", "playful", "deep", "witty", "thoughtful",
];

export const LOVE_LANGUAGES = [
    "words of affirmation",
    "quality time",
    "physical touch",
    "acts of service",
    "thoughtful gifts",
];

export const LIFESTYLE_PACE = [
    "homebody", "balanced", "social", "adventurous",
];

export const AMBITION_VIBES = [
    "career-driven", "balanced", "family-first", "creative path", "service-oriented",
];

export const FAITH_OPTIONS = [
    { value: "important", label: "Faith is important" },
    { value: "somewhat", label: "Somewhat spiritual" },
    { value: "secular", label: "Secular / not religious" },
    { value: "open", label: "Open either way" },
];

export const POLITICS_FIT = [
    { value: "must-align", label: "Must align" },
    { value: "similar", label: "Similar values" },
    { value: "open", label: "Open-minded either way" },
];

export const DEALBREAKER_CHIPS = [
    "smoking", "heavy drinking", "drugs", "doesn't want kids",
    "wants kids soon", "no commitment", "lives far", "different politics",
    "different faith", "dishonesty", "poor communication", "no growth mindset",
];
